import React from 'react';
import { connect } from 'react-redux';
import { updateStatistics } from '../../actions/statistics';

class SendStatistics extends React.Component {
    constructor(props) {
        super(props);

        const { statisticsObject } = this.props;

        if (statisticsObject && typeof window !== 'undefined') {
            this.props.sendStatistics(statisticsObject);
        }
    }

    render() {
        return null;
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        sendStatistics: (statisticsObject) => dispatch(updateStatistics(statisticsObject)),
    };
};

export default connect(null, mapDispatchToProps)(SendStatistics);
